import { Component, OnInit, TemplateRef } from '@angular/core';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { SavePackageRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.scss']
})
export class PackageComponent implements OnInit {
  modalRef: BsModalRef;
  public itemVm: SavePackageRequest = new SavePackageRequest();
  public vmListItems: any = [];
  public component_Title = 'Package';


  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';

  public deleteId: string;
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(){
    this.getList();
  }

   getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSettingService.getList("GSetting", "GetPackagesAsync", this.p, this.size, search, this.orderBy, this.sort)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }

  ngAfterViewInit() {
    // this._jq.showSpinner();
  }

  // getList() {
  //   // this._jq.showSpinner(true);
  //   this.spinner.show();
  //   this._uow.packageService.GetList().subscribe((res: any) => {
  //     this.vmListItems = res;
  //     console.log(res);
  //     this.spinner.hide();
  //     // this._jq.showSpinner();
  //   }, (err) => {
  //     console.log(err);
  //     // this._jq.showSpinner();
  //     this.spinner.hide();
  //     Swal.fire(
  //       'Failure!',
  //       'Network Issue!',
  //       'error'
  //     )
  //   });
  // }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SavePackageRequest();
      this.itemVm.spareParts = [];
      this.itemVm.services = [];
    }
  }

  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    debugger
    this._uow.gSettingService.DeletePackageAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
    }, (err) => {
      this._jq.showSpinner();
    });
  }
  // public searchTerm = '';
  // getBySearchTerm(e) {
  //   if (this.searchTerm !== ' ') {
  //     // this._jq.showSpinner(true);
  //     this.spinner.show();
  //     this._uow.packageService.GetPagedBySearch(this.searchTerm).subscribe((res: any) => {
  //       this.p = 1;
  //       this.vmListItems = res.DtlList;
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     },  (error) => {
  //       console.log(error);
  //       // this._jq.showSpinner();
  //       this.spinner.hide();
  //     });
  //   }
  // }

  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.itemVm = new SavePackageRequest();
      this.getList();
    } else {
      this._jq.showSpinner();
    }
  }
}
